// Audit rows only carry the device MAC. When the switch isn't in the
// location store (e.g. an LCD action with an unknown MAC), show the MAC
// itself rather than an empty "-". The switch may sit under a sub-location,
// so fall back to searching every location for it.
const findMachineName = (machine, allLocations) =>
  Object.values(allLocations).find((loc) => loc.devices?.[machine])?.devices[
    machine
  ].machineName;

export const formatAuditTrailSwitchName = (location, machine, allLocations) => {

  const machineName =
    allLocations[location]?.devices?.[machine]?.machineName ??
    findMachineName(machine, allLocations);
  if (!machineName) return machine;

  const locationName = allLocations[location]?.locationName;
  return locationName ? `${locationName}-${machineName}` : machineName;
};

// TES faults at a sub-location carry the parent location id, but the switch
// lives under the sub-location, so search every location for it.
export const formatAuditTrailFaultSwitchName = (
  location,
  machine,
  allLocations,
) => {

  const machineName = findMachineName(machine, allLocations);
  if (!machineName) return machine;

  const faultLocation = allLocations[location];
  const locationName =
    faultLocation?.parent_location_id != null
      ? faultLocation.specific_address
      : faultLocation?.locationName;

  return locationName ? `${locationName} - ${machineName}` : machineName;
};

export const formatAuditTrailFaultTitle = (fault, allLocations) => {
  const position =
    fault.position !== undefined ? ` (${fault.position + 1})` : '';
  const switchName = formatAuditTrailFaultSwitchName(
    fault.location,
    fault.machine,
    allLocations,
  );
  const address = fault.address ? ` - ${fault.address}` : '';

  return `${fault.faultType}${position} - ${switchName}${address}`;
};

// Command file name segment: first switch, plus how many others it covered.
// Takes the action's location -> machines map so the first switch is named
// exactly as it appears in the device list.
export const formatAuditTrailCommandSwitches = (switches, allLocations) => {
  const entries = Object.entries(switches ?? {}).flatMap(
    ([location, machines]) => machines.map((machine) => [location, machine]),
  );
  if (!entries.length) return '';

  const [[location, machine], ...rest] = entries;
  const firstName = formatAuditTrailSwitchName(location, machine, allLocations);
  return rest.length ? `${firstName}+${rest.length}` : firstName;
};
